import React from "react";

import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.scss";

import LandingScreen from "./screens/LandingScreen";
import GameScreen from "./screens/GameScreen";
import InfoScreen from "./screens/InfoScreen";
import WarningScreen from "./screens/WarningScreen";
import NotFoundScreen from "./screens/NotFoundScreen";
import GuestBookScreen from "./screens/GuestBookScreen";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingScreen />} />
          <Route path="/play" element={<GameScreen />} />
          <Route path="/warning" element={<WarningScreen />} />
          <Route path="/about" element={<InfoScreen />} />
          <Route path="/guestbook" element={<GuestBookScreen />} />
          <Route path="*" element={<NotFoundScreen />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
